import { PageHeader } from "@/components/layout/page-header";
import { ProductSection } from "@/components/product/product-section";
import { RouteSeo } from "@/components/seo/route-seo";

export default function About() {
  return (
    <div className="min-h-screen">
      <RouteSeo
        title="About Liquid Stretch | Ben Care's Vermont Formulation Journey"
        description="The story behind Liquid Stretch: a Vermont-made hemp oil born from Ben Care's personal body-care rituals, formulation work, and commitment to slow stretching and mobility practices."
        path="/about"
        type="article"
      />

      <PageHeader
        title="My Journey Through Illness and Healing"
        backgroundImage="/images/my_journey.webp"
      />

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <p>
              Before I got sick, I had already been making cannabis oils, carefully
              crafting blends with natural ingredients and always working to improve
              the recipe. I was interested in how plant-based rituals could support a
              slower relationship with the body, especially stretching, grounding, and
              quiet mobility work.
            </p>

            <p>
              Then my own health story changed. Long Covid and a difficult recovery
              forced me to pay closer attention to what my body was asking for. I
              spent a lot of time learning to move slowly, reduce sensory input, and
              stop forcing progress.
            </p>

            <p>
              Through those years, formulation became part of the practice. I kept
              testing, adjusting, and listening. Liquid Stretch was not born from a
              business plan. It came from a simple ritual: take the oil, give it time,
              move gently, and follow the cues without trying to dominate them.
            </p>

            <p>
              The current product is a handcrafted Vermont hemp oil in organic MCT
              oil, made for stretching routines, mobility work, and slow
              body-care practices. It is not presented as a cure or treatment. It is
              an intentional companion for adults who already understand hemp products
              and want to pair them with mindful movement.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-6">Why Liquid Stretch?</h2>

            <p>
              Liquid Stretch keeps the emphasis on care: small runs, lab work,
              clear use guidance, and a slower method that favors body awareness over
              intensity. The goal is simple: make stretching feel easier to stay with.
            </p>

            <p>
              This is not about making bold claims or pushing products. It is about
              sharing a practice that grew from lived experience in Vermont, then
              carrying that practice into better formulation, lab testing, and a more
              careful public product.
            </p>

            <p className="text-xl font-medium mt-12">
              All the best,<br />
              Ben
            </p>
          </div>
        </div>
      </section>

      <ProductSection />
    </div>
  );
}
